import { MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';
import { Injectable } from '@angular/core';

@Injectable()
export class MyMissingTranslationHandler implements MissingTranslationHandler {
    handle(params: MissingTranslationHandlerParams): string {
        const defaultValue = (params.interpolateParams as { [key: string]: any })?.['Default'];

        return defaultValue || params.key;
    }
}
